import { useEffect } from 'react';
import { Platform } from 'react-native';
import { Redirect, Stack } from 'expo-router';
import { useMMKVString } from 'react-native-mmkv';
import { useStores } from '@/stores/StoreProvider';
import { storage } from '@/services/auth/authStorage';

export default function WorkoutLayout() {
  const [token] = useMMKVString('access_token', storage);
  const { workoutSessionStore } = useStores();

  // Full reset when leaving the workout flow (unmount).
  // This catches back-navigation, tab switches, programmatic navigation, etc.
  // workoutSessionStore.reset() internally stops timers, cancels downloads, and clears all state.
  useEffect(() => {
    return () => {
      workoutSessionStore.reset();
    };
  }, [workoutSessionStore]);

  // Web: handle tab close / refresh while in workout flow
  useEffect(() => {
    if (Platform.OS !== 'web') return;

    const handleBeforeUnload = () => {
      workoutSessionStore.reset();
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [workoutSessionStore]);

  // Web: handle browser back button as a safety net.
  // The unmount effect above should handle this, but Expo Router may not
  // always unmount the layout synchronously on popstate.
  useEffect(() => {
    if (Platform.OS !== 'web') return;

    const handlePopState = () => {
      workoutSessionStore.reset();
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [workoutSessionStore]);

  if (!token) {
    return <Redirect href="/" />;
  }

  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="pre-workout" />
      <Stack.Screen name="player" />
      <Stack.Screen name="complete" />
    </Stack>
  );
}
